import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import HighSchoolGraduationTypeService from "../../../Services/HighSchoolGraduationType.service";
import HighSchoolGraduationTypeLookupModal from "./HighSchoolGraduationTypeLookupModal";
const makeSearchArgs = {
    loadOptions: (search, options) => HighSchoolGraduationTypeService.search({
        ids: options === null || options === void 0 ? void 0 : options.ids,
        query: search || (options === null || options === void 0 ? void 0 : options.query),
        names: options === null || options === void 0 ? void 0 : options.names,
        srcSystemIds: options === null || options === void 0 ? void 0 : options.srcSystemIds,
    }, { max: 20 }).then(({ data }) => data),
    label: "name",
    value: "id",
};
export const HighSchoolGraduationTypeSearch = makeSearch(makeSearchArgs);
export const HighSchoolGraduationTypeMultiSearch = makeMultiSearch(Object.assign(Object.assign({}, makeSearchArgs), { 
    // @ts-expect-error - TS2322 - Type 'ComponentType<WithModalParams<LookupModalProps<HighSchoolGraduationType, any>>>' is not assignable to type 'ComponentType<never> | undefined'.
    lookupModal: HighSchoolGraduationTypeLookupModal }));
